import { endpoints } from 'zylo_schema/contracts/endpoints';
import { mockRequestHandler } from '..';
import { usersStore } from './usersStore';

export const usersHandlers: mockRequestHandler[] = [
  {
    endpoint: '/user',
    method: 'get',
    response: ({ query }) => {
      const { user_id } = query;
      const user = usersStore.find(({ id }) => id.toString() === user_id);
      const response: endpoints['get_user']['responses'] = user
        ? {
            status: 200,
            data: user,
          }
        : {
            status: 404,
            data: { message: 'User not found' },
          };
      return response;
    },
  },
];
